// useHeaderV3Enabled — F9.2 WAVE 2B kill-switch reader.
// Mirrors useLandingV3Enabled. Cached per mount.
import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

export default function useHeaderV3Enabled() {
    const [state, setState] = useState({ loading: true, enabled: false, error: null });

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const data = await apiFetch("/kill-switches/header-v3-enabled");
                if (mounted) setState({ loading: false, enabled: !!data.enabled, error: null });
            } catch (e) {
                if (mounted) setState({ loading: false, enabled: false, error: e });
            }
        })();
        return () => { mounted = false; };
    }, []);

    return state;
}
